import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import moment from "moment";
import { pdf } from "@react-pdf/renderer";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { Icon } from "@cdk-uip/react-icon";
import { PageSpinner } from "@cdk-uip/react-page-spinner";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport
} from "react-bootstrap-table2-toolkit";

import { candidateActions } from "../../actions/candidateActions";
import Dialog from "../common/Dialog";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { onBoardingActions } from "../../actions/onBoardingActions";
import ManageUsers from "../Users/ManageUsers";
import ITSetup from "../Users/ITSetup";
import OnboardingMain from "../OnboardingForms/PDFTemplates/OnboardingMain";
import {
  ROLES,
  CANDIDATE_STATUS,
  defaultToastOptions
} from "../../constants/constants";
import api from "../../api/candidate.resource";
import {
  b64toBlob,
  getStatusDescription,
  getFormattedDate,
  sortByDate,
  sortDatesWithEmptyValues,
  getEmployeeTypeDescription
} from "../../util/helpers";
import store from "../../store";
import VerticalContextMenu from "./VerticalContextMenu";

export const CandidateList = ({
  history,
  getCandidateDetails,
  getGendersList,
  getMaritalStatusList,
  getRelationShipList,
  getStatesList,
  updateCandidatesList
}) => {
  const [candidatesList, setCandidatesList] = useState([]);
  const [showITSetup, setShowITSetup] = useState(false);
  const [showDeleteUserWarning, setShowDeleteUserWarning] = useState(false);
  const [showEmailUserAlert, setShowEmailUserAlert] = useState(false);
  const [showOnboardUserMessage, setShowOnboardUserMessage] = useState(false);
  const [showAddUser, setShowAddUser] = useState(false);
  const [selectedUser, setSelectedUser] = useState({});
  const [loading, setLoading] = useState(false);
  const [isDownloadingProgress, setIsDownloadingProgress] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const columns = [
    {
      dataField: "firstName",
      text: "Name",
      headerStyle: { width: "16%" },
      sort: "true",
      formatter: (cellContent, row) => {
        return `${row.firstName} ${row.lastName}`;
      }
    },
    {
      dataField: "contactNumber",
      text: "Mobile Number",
      headerStyle: { width: "10%" }
    },
    {
      dataField: "emailId",
      text: "Email Id",
      headerStyle: { width: "22%" },
      sort: "true"
    },
    {
      dataField: "statusDescription",
      text: "Status",
      headerStyle: { width: "7%" },
      sort: "true"
    },
    {
      dataField: "employeeType",
      text: "Employee Type",
      headerStyle: { width: "12%" },
      sort: "true"
    },
    {
      dataField: "dateofJoining",
      text: "Joining Date",
      headerStyle: { width: "10%" },
      sort: "true",
      formatter: (cellContent, row) => {
        return (
          (row.dateofJoining &&
            moment(row.dateofJoining, "YYYY-MM-DD")
              .format("DD/MM/YYYY")
              .toString()) ||
          ""
        );
      },
      sortFunc: (a, b, order) => sortDatesWithEmptyValues(a, b, order)
    },
    {
      dataField: "lastUpDatedDate",
      text: "Updated Date",
      headerStyle: { width: "13%" },
      sort: "true",
      sortFunc: (a, b, order) => sortByDate(a, b, order)
    },
    {
      dataField: "",
      text: "Actions",
      headerStyle: { width: "12%" },
      csvExport: false,
      formatter: (cellContent, row) => {
        return (
          <Fragment>
            <span className="candidate-list-icons">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 200 }}
                overlay={renderTooltip("View Report")}
              >
                <Icon onClick={() => handleOnClickViewCandidate(row.id)}>
                  visibility
                </Icon>
              </OverlayTrigger>
            </span>
            <span className="candidate-list-icons">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 200 }}
                overlay={renderTooltip("Edit User")}
              >
                <Icon onClick={() => handleOnClickEditCandidate(row.id)}>
                  edit
                </Icon>
              </OverlayTrigger>
            </span>
            <span className="candidate-list-icons">
              <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 200 }}
                overlay={renderTooltip("Download Documents")}
              >
                <Icon onClick={() => handleOnClickDownloadDocs(row)}>
                  file_download
                </Icon>
              </OverlayTrigger>
            </span>
            <OverlayTrigger
              placement="top"
              delay={{ show: 250, hide: 200 }}
              overlay={renderTooltip("More Option")}
            >
              <span>
                <VerticalContextMenu
                  statusId={row.status}
                  sendEmail={() => handleOnClickEmailCredentials(row)}
                  cloudDownload={() => getOnboardingPDF(row)}
                  sendOnboardingInvitation={() =>
                    handleOnClickOnboardingInvitation(row)
                  }
                  viewOnboardingPdf={() => handleOnClickViewOnboardingPDF(row)}
                  editOnboardingPdf={() =>
                    handleOnClickEditOnboardingPDF(row.id)
                  }
                  setShowITSetup={() => handleOnClickITSetup(row)}
                  deleteCandidate={() => handleOnClickDeleteCandidate(row)}
                />
              </span>
            </OverlayTrigger>
          </Fragment>
        );
      }
    }
  ];

  const sizePerPageList = [
    {
      text: "5",
      value: 5
    },
    {
      text: "10",
      value: 10
    },
    {
      text: "20",
      value: 20
    }
  ];

  const getCandidatesList = async () => {
    try {
      setLoading(true);
      const response = await api.getCandidatesList();
      setCandidatesList(response);
    } catch (error) {
      console.log("error while fetching candidate list :>> ", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOnClickViewCandidate = candidateId => {
    history.push({
      pathname: "/CandidateReport",
      state: {
        candidateId
      }
    });
  };
  const handleOnClickEditCandidate = candidateId => {
    history.push({
      pathname: "/CandidateForm",
      state: {
        candidateId
      }
    });
  };

  const handleOnClickDeleteCandidate = candidate => {
    setSelectedUser(candidate);
    setShowDeleteUserWarning(prevState => !prevState);
  };

  const handleOnClickEmailCredentials = candidate => {
    setSelectedUser(candidate);
    setShowEmailUserAlert(true);
  };

  const handleOnClickOnboardingInvitation = candidate => {
    setSelectedUser(candidate);
    setShowOnboardUserMessage(true);
  };

  const handleOnClickITSetup = candidateDetails => {
    setShowITSetup(true);
    setSelectedUser(candidateDetails);
  };

  const getOnboardingDetails = async employee => {
    await getCandidateDetails(employee.id);
    await getGendersList();
    await getMaritalStatusList();
    await getStatesList();
    await getRelationShipList();
  };

  const handleOnClickViewOnboardingPDF = async employee => {
    setShowSpinner(true);
    await getOnboardingDetails(employee);
    setShowSpinner(false);
    history.push({
      pathname: "/OnboardingPDF",
      state: {
        employee
      }
    });
  };

  const handleOnClickEditOnboardingPDF = candidateId => {
    history.push({
      pathname: "/OnboardingForms",
      state: {
        candidateId
      }
    });
  };

  const handleOnboardingCandidatesReport = () => {
    history.push("/OnboardingCandidatesReport")
  }
  
  const handleOnClickAddUser = () => setShowAddUser(true);
  const handleOnCloseAddUser = () => {
    setShowAddUser(false);
    getCandidatesList();
  };

  const getOnboardingPDF = async employee => {
    setShowSpinner(true);
    await getOnboardingDetails(employee);
    const blob = await pdf(<OnboardingMain store={store} />).toBlob();
    setShowSpinner(false);
    saveAs(blob, employee.fullNameAdhaarCard);
  };

  const zipAndDownloadDocuments = (userDocuments, zipFileName) => {
    try {
      const zip = new JSZip();
      const folder = zip.folder("documents");
      userDocuments.forEach(document => folder.file(document.name, document));
      folder
        .generateAsync({ type: "blob" })
        .then(content => saveAs(content, zipFileName));
    } catch (e) {
      toast.configure();
      toast.error(`Error while Downloading Documents`, defaultToastOptions);
    }
  };
  const handleOnClickDownloadDocs = async candidate => {
    try {
      toast.configure();
      setIsDownloadingProgress(true);
      const res = await api.getUserDocuments(candidate.id);
      if (res) {
        if (!res.errorMessage) {
          const userDocuments = res.map(file => {
            return new File([b64toBlob(file.byteData, file.type)], file.name, {
              type: file.type
            });
          });
          if (userDocuments && userDocuments.length) {
            const zipFileName = `${candidate.firstName}_${candidate.lastName}`;
            zipAndDownloadDocuments(userDocuments, zipFileName);
          }
        } else {
          toast.warn(res.errorMessage, defaultToastOptions);
        }
      }
    } catch (e) {
      toast.error(`Error while fetching Documents`, defaultToastOptions);
    } finally {
      setIsDownloadingProgress(false);
      setSelectedUser({});
    }
  };
  const deleteCandidate = async () => {
    try {
      toast.configure();
      setShowDeleteUserWarning(false);
      const userDetails = { id: selectedUser.id };
      const res = await api.deleteUser(userDetails);
      if (res) {
        if (res.errorMessage) {
          toast.warn(res.errorMessage, defaultToastOptions);
        } else {
          toast.success(`Successfully Deleted User`, defaultToastOptions);
          getCandidatesList();
        }
      }
    } catch (e) {
      toast.error(`Error while Deleting User`, defaultToastOptions);
    } finally {
      setSelectedUser({});
    }
  };
  const inviteUser = async () => {
    try {
      toast.configure();
      setShowEmailUserAlert(false);
      const res = await api.inviteUser({ id: selectedUser.id });
      if (res) {
        if (res.errorMessage) {
          toast.warn(res.errorMessage, defaultToastOptions);
        } else {
          toast.success(`Successfully Invited User`, defaultToastOptions);
        }
      }
    } catch (e) {
      toast.error(`Error while Inviting User`, defaultToastOptions);
    } finally {
      setSelectedUser({});
    }
  };

  const onboardUser = async () => {
    try {
      toast.configure();
      setShowOnboardUserMessage(false);
      const res = await api.onBoardUser({
        id: selectedUser.id,
        status: CANDIDATE_STATUS.ONBOARDING.id,
        dateofJoining: moment(new Date()).format("YYYY-MM-DDT00:00:00")
      });
      if (res) {
        if (res.errorMessage) {
          toast.warn(res.errorMessage, defaultToastOptions);
        } else {
          updateCandidatesList(
            selectedUser.id,
            "status",
            CANDIDATE_STATUS.ONBOARDING.id
          );
          toast.success(
            `Successfully Invited User for Onboarding`,
            defaultToastOptions
          );
        }
      }
    } catch (e) {
      toast.error(
        `Error while sending onboarding Invitation`,
        defaultToastOptions
      );
    } finally {
      setSelectedUser({});
    }
  };
  const getUserData = () => {
    return candidatesList && candidatesList.length
      ? candidatesList.map(user => ({
          ...user,
          statusDescription: getStatusDescription(user.status),
          lastUpDatedDate: getFormattedDate(
            user.updatedDate || user.createdDate,
            true
          ),
          employeeType: getEmployeeTypeDescription(user.cDKEmployeeType)
        }))
      : [];
  };

  useEffect(() => {
    getCandidatesList();
  }, []);

  const renderTooltip = message => {
    return <Tooltip id={message}>{message}</Tooltip>;
  };
  return (
    <Fragment>
      <PageSpinner show={isDownloadingProgress || showSpinner} />
      <div className="mt-3 mr-3 candidate-info">
        <div style={{ textAlign: "left" }}>
          <h5> Candidates Information</h5>
        </div>
        <ToolkitProvider
          keyField="id"
          data={getUserData()}
          columns={columns}
          search
          exportCSV={{ fileName: "Candidates.csv" }}
        >
          {props => (
            <Fragment>
              <div className="candidates-search-bar">
                <SearchBar {...props.searchProps} />
                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 200 }}
                  overlay={renderTooltip("Add User")}
                >
                  <Icon
                    onClick={handleOnClickAddUser}
                    className="on-hover add-user-icon ml-2"
                  >
                    person_add
                  </Icon>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 200 }}
                  overlay={renderTooltip("Onboarding Candidates Report")}
                >
                  <Icon
                    onClick={handleOnboardingCandidatesReport}
                    className="on-hover add-user-icon"
                  >
                    view_list
                  </Icon>
                </OverlayTrigger>

                <OverlayTrigger
                  placement="top"
                  delay={{ show: 250, hide: 200 }}
                  overlay={renderTooltip("Export to CSV")}
                >
                  <ExportCSVButton {...props.csvProps} className="report-csv-download">
                    <Icon>file_download</Icon>
                  </ExportCSVButton>
                </OverlayTrigger>
              </div>
              <BootstrapTable
                {...props.baseProps}
                striped
                condensed
                bootstrap4
                pagination={paginationFactory({
                  sizePerPage: 10,
                  sizePerPageList: sizePerPageList
                })}
                noDataIndication={
                  loading ? "Loading....." : "No employees are available."
                }
              />
            </Fragment>
          )}
        </ToolkitProvider>
      </div>
      {showAddUser && (
        <ManageUsers roleId={ROLES.CANDIDATE} onClose={handleOnCloseAddUser} />
      )}
      {showITSetup && (
        <ITSetup
          selectedUser={selectedUser}
          onClose={() => setShowITSetup(false)}
        />
      )}
      {showDeleteUserWarning && (
        <Dialog
          header="Delete User"
          message={`Are you sure you want to delete ${selectedUser.firstName} ${selectedUser.lastName}?`}
          closeButtonText="CLOSE"
          saveButtonText="DELETE"
          handleClose={() => {
            setShowDeleteUserWarning(false);
            setSelectedUser({});
          }}
          handleSave={() => deleteCandidate()}
        />
      )}
      {showEmailUserAlert && (
        <Dialog
          header="Invite User"
          message={`Would you like to Email User Credentials to ${selectedUser.firstName} ${selectedUser.lastName}?`}
          closeButtonText="CANCEL"
          saveButtonText="SEND"
          handleClose={() => {
            setShowEmailUserAlert(false);
            setSelectedUser({});
          }}
          handleSave={() => inviteUser()}
        />
      )}
      {showOnboardUserMessage && (
        <Dialog
          header="User Onboarding Invitation"
          message={`Would you like to send onboarding invitation to ${selectedUser.firstName} ${selectedUser.lastName}?`}
          closeButtonText="CANCEL"
          saveButtonText="OKAY"
          handleClose={() => {
            setShowOnboardUserMessage(false);
            setSelectedUser({});
          }}
          handleSave={() => onboardUser()}
        />
      )}
    </Fragment>
  );
};
const mapStateToProps = ({ candidateDetails }) => ({
  candidatesList: candidateDetails.candidatesList || []
});
const mapDispatchToProps = {
  getCandidateDetails: onBoardingActions.getPersonalDetails,
  getCandidatesList: candidateActions.getCandidatesList,
  getGendersList: candidateActions.getGendersList,
  getMaritalStatusList: candidateActions.getMaritalStatusList,
  getRelationShipList: onBoardingActions.getRelationShipList,
  getStatesList: candidateActions.getStatesList,
  updateCandidatesList: candidateActions.updateCandidatesList
};

export default connect(mapStateToProps, mapDispatchToProps)(CandidateList);
